import { LoggingComponent } from 'src/app/components/misc/logging/logging.component';
import { CrudComponent } from 'src/app/components/templates/crud/crud.component';

export const CRUD_IMPORTS = [CrudComponent, LoggingComponent] as const;
